import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import RoutesComponent from './routes/RoutesComponent';
import useAuth from './hooks/useAuth';
import { ThemeProvider } from './context/ThemeContext';

import './App.css';

import { AuthProvider } from './context/AuthContext';

const App = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, var(--app-color), #8B5CF6)'}}>
        <div className="text-center text-white">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-8 backdrop-blur-sm">
            <span className="text-4xl font-bold">E</span>
          </div>
          
          <h1 className="text-4xl font-bold mb-4">Esti.kz</h1>
          <p className="text-xl text-blue-100 mb-8">Қазақ тіліндегі аудиокітаптар сервисі</p>
          
          <div className="flex justify-center space-x-2 mb-8">
            <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce"></div>
            <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
            <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          </div>
          
          <div className="text-sm text-blue-200">
            Сервис дайындалуда...
          </div>
        </div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <RoutesComponent user={user} />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;